import axiosInstance from './axiosInstance'

export const getPedestalDecorationOptionById = (optionId) => {
  return axiosInstance.get(`/pedestal-decoration-options/${optionId}`)
}

export const getPedestalDecorationOptions = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
  return axiosInstance.get(`/pedestal-decoration-options?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createPedestalDecorationOption = (data) => {
  return axiosInstance.post('/pedestal-decoration-options', data)
}

export const updatePedestalDecorationOption = (optionId, data) => {
  return axiosInstance.put(`/pedestal-decoration-options/${optionId}`, data)
}

export const deletePedestalDecorationOption = (optionId) => {
  return axiosInstance.delete(`/pedestal-decoration-options/${optionId}`)
}
